import { FormControlLabel, Checkbox } from '@mui/material';

interface AutosizeColumnsToggleProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export const AutosizeColumnsToggle: React.FC<AutosizeColumnsToggleProps> = ({
  checked = false,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    onChange?.(newChecked);
  };

  return (
    <FormControlLabel
      data-testid="autosize-toggle"
      control={
        <Checkbox
          data-testid="autosize-toggle-input"
          checked={checked}
          onChange={handleChange}
          color="primary"
          disabled={disabled}
        />
      }
      label="Autosize"
      sx={{
        ml: '4px',
        opacity: disabled ? 0.6 : 1,
      }}
    />
  );
};

export default AutosizeColumnsToggle;
